import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@babackapp/ui/components/popover";
import { PropsWithChildren } from "react";

export interface FacetedFilterTypeProps extends PropsWithChildren {
  label: string;
}

export default function FacetedFilterType(props: FacetedFilterTypeProps) {
  const { children, label } = props;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div
          className={
            "bg-background hover:bg-accent hover:text-accent-foreground px-2 h-full flex items-center justify-center cursor-pointer text-sm font-medium"
          }
        >
          {label}
        </div>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start">
        {children}
      </PopoverContent>
    </Popover>
  );
}
